import { Input, InputProps } from '@mui/material'
import React from 'react'

const InputWrapper: React.FC<InputProps> = ({ ...props }) => (
  <Input {...props} />
)

export default InputWrapper
